import React, { Component } from "react";
import "./ExpandableField.scss";
import classNames from "classnames";
import { IApplicationState } from "src/spintr/reducer";
import { connect } from 'react-redux';
import { MediumBodyBolder } from "src/components/Text";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import TinyFormattedContent from "./Tiny/displayment/TinyFormattedContent";

interface IProps {
    title: string;
    text: string;
    instanceColor: string;
}
interface IState {
    showContent: boolean;
}

let nextFieldId = 0;

class ExpandableField extends Component<IProps, IState> {
    state = {
        showContent: false,
    };

    private contentId = "ExpandableField-content-" + (++nextFieldId);

    public render() {
        const isExpanded = this.state.showContent;

        return (
            <div
                className={classNames("ExpandableFieldWrapper", {
                    ["isExpanded"]: isExpanded,
                })}
            >
                <div className="ExpandableField">
                    {/* A button, not a heading: Enter and Space toggle it and it stays out of the table of contents */}
                    <button
                        type="button"
                        className={classNames("header", {
                            ["isExpanded"]: isExpanded,
                        })}
                        aria-expanded={isExpanded}
                        aria-controls={this.contentId}
                        onClick={() => {
                            this.setState({ showContent: !isExpanded });
                        }}
                    >
                        <MediumBodyBolder as="span" weight="semiBold" lineHeight="high" color="contentDark" className="title">
                            {this.props.title}
                        </MediumBodyBolder>
                        <Visage2Icon
                            className="chevron"
                            icon="arrow-right-s-line"
                            type="custom"
                            color="dark-grey"
                            rotation={isExpanded ? 270 : 90} />
                    </button>
                    <div id={this.contentId}>
                        {isExpanded && (
                            <TinyFormattedContent content={this.props.text} className={"isExpanded"} />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState, props) => {
    return {
        ...props,
        instanceColor: state.instance.get("color"),
    };
};

export default connect(mapStateToProps)(ExpandableField);
